export default __webpack_public_path__ + "static/media/gtx.bcd6c763.png";